import React, { useContext, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import styled, { ThemeContext } from "styled-components";
import axios from "axios/index";

// https://www.npmjs.com/package/react-star-ratings
import StarRatings from "react-star-ratings";

import { getIconForCategory } from "./utils";
import { getSelectedGuideCategory } from "./selectors";
import { MapPinIcon } from "./icons";
import { plotRoute } from "./actions";
import { getFacilityCoordinates } from "../../store";

export const LocationCard = ({ cardData }) => {
  const selectedCategory = useSelector(getSelectedGuideCategory);
  const startPos = useSelector(getFacilityCoordinates);
  const Icon = getIconForCategory(selectedCategory);
  const [distance, setDistance] = useState(null);

  const theme = useContext(ThemeContext);

  const { name, address, rating, reviews, coordinates, image_url: imgSrc } = cardData;

  const apiDomain = window.location.host.includes("localhost")
    ? "http://127.0.0.1:8000"
    : "https://api.talkfurther.com";

  useEffect(() => {
    async function fetchRoute() {
      const { data: routing } = await axios.get(
        `${apiDomain}/api/chat/guide-route?route_start=${startPos.join(",")}&route_end=${coordinates.join(",")}`
      );

      const path = routing.paths[0];
      // Add your own result handling here
      console.log({ distance: path.distance });
      if (path.distance < 1000) {
        setDistance(`${Math.floor(path.distance)} m`);
      } else {
        setDistance(`${+parseFloat(path.distance / 1000).toFixed(1)} km`);
      }
    }
    fetchRoute();
  }, [apiDomain, coordinates, startPos]);

  return (
    <CardWrapper>
      <div
        style={{
          // WHY DOES NOT WORK AS A STYLED COMPONENT?!
          flex: 1,
          width: "337px",
          height: "282px",
          borderRadius: "12px",
          background: `url(${imgSrc}) center center / cover no-repeat`, // THIS IS FUCKING BEYOND!
        }}
      />
      <div className="info">
        <div className="title">
          <Icon color={theme.brandColor} size={30} />
          <span>{name}</span>
        </div>

        <div className="rating">
          <StarRatings
            rating={rating}
            starDimension="24px"
            starSpacing="0"
            starRatedColor="#ff9e03"
            starEmptyColor="#eee"
          />
        </div>

        <div className="geo" onClick={() => plotRoute(startPos, coordinates)}>
          <span className="pin">
            <MapPinIcon /> {distance}
          </span>
          <span className="address">{address}</span>
        </div>

        <div className="reviews">
          {reviews.map((r, i) => (
            <div key={i}>{r}</div>
          ))}
        </div>
      </div>
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  background-color: white;
  border-radius: 16px;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.12);
  padding: 27px;
  display: flex;
  width: 762px;

  &:not(:first-of-type) {
    margin-top: 18px;
  }

  .title {
    font-weight: 900;
    font-size: 26px;
    line-height: 36px;

    svg {
      vertical-align: text-bottom;
    }

    span {
      margin-left: 10px;
    }
  }

  .info {
    flex: 1;
    display: inline-block;
    margin-left: 34px;
    vertical-align: top;
  }

  .rating {
    margin-top: 8px;
    margin-bottom: 16px;
  }

  .geo {
    padding-bottom: 28px;
    margin-bottom: 19px;
    border-bottom: 1px solid #cdcdcd;

    cursor: pointer;

    .pin {
      color: #cdcdcd;
      font-weight: 800;
      font-size: 16px;
      line-height: 22px;
    }

    .address {
      margin-left: 5px;

      font-weight: 800;
      font-size: 16px;
      line-height: 22px;
    }
  }

  .reviews {
    font-weight: 800;
    font-size: 16px;
    line-height: 26px;

    div {
      max-width: 330px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    div:after,
    div:before {
      content: "\\0022";
    }
  }
`;
